const searchResult = (limit, items) => ({
  loading: false,
  showingResultCount: limit,

  init(){
    window.addEventListener("search-more", (event)=>{
      this.loadMore(event)
    })

  },
  calculateProgressBarWidth(count){
    return (+count * 100) / parseInt(items)  + '%'
  },
  loadMore(event){
    this.loading = true;
    console.log(event.detail.new_url)
    fetch(event.detail.new_url)
      .then(response => response.text())
      .then(data => {
        let html_div = document.createElement('div');
        html_div.innerHTML = data;

        const button = document.querySelector('#search-pagination .button');
        const href = button.getAttribute('href');
        const url = new URL(href, window.location.origin);
        const pageValue = url.searchParams.get('page');
        if(pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
          document.querySelector('#search-pagination').style.display = 'none';
        }

        let html_dom = html_div.querySelector('#search_grid').innerHTML;

        if (document.querySelector('#search_grid')){
          document.querySelector('#search_grid').innerHTML += html_dom;
        }

        this.showingResultCount = document.querySelectorAll('.product-card').length

        this.calculateProgressBarWidth(this.showingResultCount)

        if (html_div.querySelector('#search-pagination')){
          let pagination_dom = html_div.querySelector('#search-pagination').innerHTML;
          if(document.querySelector('#search-pagination')) {
            document.querySelector('#search-pagination').innerHTML = pagination_dom;
          }
        }
      })
      .catch(error => console.error('Error:', error))
      .finally(() => this.loading = false);
  }

})

export default searchResult

window.addEventListener("alpine:init", ()=>{
  Alpine.data("searchResults", searchResult)
})